// extracted by mini-css-extract-plugin
module.exports = {"root":"layout_root__39Ulm","disableGutters":"layout_disableGutters__1yoyZ"};